<template>
  <div class="row">
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h5>Asset Type Lists</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <div class="form-inline ml-auto">
              <div class="button-group ">
                <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                  <i class="fa fa-filter" aria-hidden="true"></i>
                    Filter
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu p-2" >
                  <span>Company:</span>
                  <div class="dropdown-divider"></div>
                  <li v-for="ct in companyList" :key="ct.id">
                    <a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" :value="ct.company_no" v-model="filterCompany"/>&nbsp; {{ ct.name }}</a>
                  </li>
                </ul>
                <button type="button" class="btn btn-sm btn-soft-primary" @click="addAsset">
                    <i class="fa fa-plus" aria-hidden="true"></i> New
                </button>
                <button type="button" class="btn btn-sm btn-soft-outline-primary" @click="refreshList">
                  <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                </button>
                rows:
                <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                  <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                </select>
                <span class="mr-1">
                  Total rows: <b>{{ rowsTotal }}</b>
                </span>
              </div>
              <div class="form-group mx-sm-3 mb-2">
                  <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
              </div>
              <span class="mr-1">
                page:
                <select v-model="currentPage">
                  <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                </select>
                / {{ pageLength }}
              </span>
              <nav aria-label="Page navigation example" class="pull-right">
                  <ul class="pagination">
                      <li class="page-item">
                          <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                              <i class="fa fa-angle-left" aria-hidden="true"></i>
                          </a>
                      </li>
                      <li class="page-item">
                          <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                              <i class="fa fa-angle-right" aria-hidden="true"></i>
                          </a>
                      </li>
                  </ul>
              </nav>
            </div>
            <table class="table table-item mb-0 table-sm table-hover">
              <thead>
                  <tr>
                      <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                          {{ t.name }}
                          <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                      </th>
                  </tr>
              </thead>
              <tbody>
                <tr v-if="filterData.length < 1">
                  <td colspan="9" style="text-align: center;"><i>No Data</i></td>
                </tr>
                <tr v-for="d in filterData" :key="d.id" @click="editData(d.id)" style="cursor: pointer">
                  <td>{{ d.name }}</td>
                  <td><b>{{ d.account_asset }}</b> - {{ d.acc_asset}}</td>
                  <td><b>{{ d.account_akumulasi }}</b> - {{ d.acc_akumulasi}}</td>
                  <td><b>{{ d.account_biaya_akumulasi }}</b> - {{ d.acc_biaya_akumulasi}}</td>
                  <td>{{ d.company }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { assetUrl, getHeader } from '@/config'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'AssetTypeList',
  components: { Loading },
  data () {
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      filterCompany: [],
      filterOutlet: [],
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 25,
      currentPage: 1,
      title: [{
        name: 'Name',
        prop: 'name'
      }, {
        name: 'Account Asset',
        prop: 'account_asset'
      }, {
        name: 'Account Akumulasi',
        prop: 'account_akumulasi'
      }, {
        name: 'Account Biaya Akumulasi',
        prop: 'account_biaya_akumulasi'
      }, {
        name: 'Company',
        prop: 'company'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
    this.$store.dispatch('getRowTable')
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    editData: function (id) {
      axios.get(assetUrl + '/type/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('editAsset', response.data.data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    addAsset: function () {
      this.$emit('newAsset')
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      axios.get(assetUrl + '/type', { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
        })
        .catch(error => {
          this.$Progress.fail()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList,
      rowsTable: state => state.data.rowsTable
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.dataRaw.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no.toString().toLowerCase().indexOf(this.filterCompany[i].toString().toLowerCase()) > -1) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  }
}
</script>
